export const CookiesName = "bet247_website_security";

/** Persist auth token; only use Secure flag on HTTPS (localhost HTTP must work). */
export const setAuthCookie = (cookieLib, token) => {
  const secure =
    typeof window !== "undefined" && window.location.protocol === "https:";
  cookieLib.set(CookiesName, token, {
    expires: 365,
    secure,
    sameSite: "strict",
    path: "/",
  });
};

// export const ValidationErrorsSet = async (setError, errors) => {
//   for (const key in errors) {
//     if (errors.hasOwnProperty(key)) {
//       const messages = errors[key];
//       if (Array.isArray(messages) && messages.length > 0) {
//         setError(key, {
//           message: messages[0], // Show the first error message
//         });
//       }
//     }
//   }
// };

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));
  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const ValidationErrorsSet = async (setError, errors) => {
  for (const key in errors) {
    if (errors.hasOwnProperty(key)) {
      setError(key, {
        message: errors[key],
      });
    }
  }
};

export function ConvertToTimeZoneAccording(date, timeZone = "GMT") {
  const utcDate = new Date(date);
  const localDate = new Date(
    utcDate.toLocaleString("en-US", {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }),
  );
  // console.log(timeZone);
  // console.log(Intl.DateTimeFormat().resolvedOptions().timeZone);

  // Format the date to "YYYY-MM-DD HH:mm"
  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(localDate.getDate()).padStart(2, "0");
  const hours = String(localDate.getHours()).padStart(2, "0");
  const minutes = String(localDate.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes} / ${day}-${month}-${year}`;
  // return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export function ConvertToTime(date) {
  const localDate = new Date(date);
  const hours = String(localDate.getHours()).padStart(2, "0");
  const minutes = String(localDate.getMinutes()).padStart(2, "0");
  const seconds = String(localDate.getSeconds()).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
}

export function ConvertToDate(date) {
  const localDate = new Date(date);
  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(localDate.getDate()).padStart(2, "0");

  return `${day}-${month}-${year}`;
}

export function GetRandomDatetimeForKeys() {
  const year = Math.floor(Math.random() * 1000) + 2000;
  const month = String(Math.floor(Math.random() * 12) + 1).padStart(2, "0");
  const day = String(Math.floor(Math.random() * 28) + 1).padStart(2, "0");
  const hour = String(Math.floor(Math.random() * 24)).padStart(2, "0");
  const minute = String(Math.floor(Math.random() * 60)).padStart(2, "0");
  const second = String(Math.floor(Math.random() * 60)).padStart(2, "0");
  return `${year}${month}${day}${hour}${minute}${second}`;
}

export const IMG_SIZE = {
  HomePage: {
    Banner: {
      width: 1309,
      height: 538,
    },
    OurFeatures: {
      width: 260,
      height: 254,
    },
    SocialMedia: {
      width: 184,
      height: 184,
    },
  },
  AboutUsPage: {
    Banner: {
      width: 1309,
      height: 538,
    },
    WhyChooseUs: {
      width: 184,
      height: 184,
    },
    OurTeam: {
      width: 331,
      height: 372,
    },
  },
};
